module.exports = __webpack_public_path__ + "img/globe2.520c42fc.svg";